import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.main`
  /* max-width: 1120px; */
  margin-right: 80px;
  display: flex;
`;

export const ContentArea = styled.main`
  /* position: absolute; */
  height: 100vh;

  margin-left: 250px;

  h1 {
    margin-top: 40px;
  }
`;

export const FormContainer = styled.div`
  margin-top: 0;
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  column-gap: 1.6rem;
  row-gap: 1.6rem;

  a {
    text-decoration: none;
    color: #323a55;
  }

  label {
    cursor: pointer;
  }

  .birthDiv {
    margin-top: 20px;
  }
`;

export const RadioContainer = styled.div`
  margin-top: 15px;
  input[type='radio'] {
    display: none;
  }

  label:before {
    content: ' ';
    display: inline-block;
    position: relative;
    top: 5px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    border: 2px solid #09432f;
    background-color: transparent;
  }

  input[type='radio']:checked + label:before {
    position: relative;
    border: 2px solid #09432f;
    border-radius: 11px;
    width: 20px;
    height: 20px;
    top: 5px;
    content: ' ';
    display: inline-block;
    background-color: #00b35b;
  }
`;
